export const endpoints = {
    notice: "/whvstore/notice/",
    client: '/whvstore/client/',
}
